"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var StateManager = /** @class */ (function () {
    function StateManager() {
        this._state = {};
    }
    Object.defineProperty(StateManager.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (value) {
            this.setState(value);
        },
        enumerable: true,
        configurable: true
    });
    StateManager.prototype.setState = function (state) {
        this._state = Object.assign({}, this._state, state);
    };
    StateManager.prototype.getState = function (key, factory) {
        var r = this._state[key];
        if (r === undefined && factory) {
            r = factory();
            this._state[key] = r;
        }
        return r;
    };
    __decorate([
        mobx_1.observable
    ], StateManager.prototype, "_state", void 0);
    __decorate([
        mobx_1.computed
    ], StateManager.prototype, "state", null);
    __decorate([
        mobx_1.action
    ], StateManager.prototype, "setState", null);
    __decorate([
        mobx_1.action
    ], StateManager.prototype, "getState", null);
    return StateManager;
}());
exports.StateManager = StateManager;
